<template>
	<div class="row">
		<div class="col-12 pl-4 pr-4 font-size-11 font-size-sm-9" v-show="Object.values(transactionOne).length == 0">
			<vcl :width='400' :height='250'>
						<rect x="0" y="0" rx="2" ry="2" width="430" height="26" />
						<rect x="0" y="38" rx="2" ry="2" width="430" height="28" />
						<rect x="0" y="78" rx="2" ry="2" width="430" height="28" />
						<rect x="0" y="118" rx="2" ry="2" width="430" height="28" />
						<rect x="0" y="158" rx="2" ry="2" width="430" height="28" />
						<rect x="0" y="200" rx="2" ry="2" width="430" height="28" />
			</vcl>
		</div>
		<div class="col-12 pl-4 pr-4 font-size-11 font-size-sm-9" v-if="Object.values(transactionOne).length > 0">
			<div v-if="transactionOne.trx_status==9">
				<div class="row">
					<div class="col-12 pt-3 pb-3 pt-lg-4 pb-lg-4 bg-green-light cus-box-shadow border-right-green">
						<div class="row">
							<div class="col-sm-2 col-lg-1 text-green2 text-md-center text-lg-center font-size-20 mt-2 mt-lg-n2 position-absolute">
								<div><i class="far fa-check-circle"></i></div>
							</div>
							<div class="col-sm-10 col-lg-6 offset-2 offset-lg-1">
								<div>Selesai</div>
							</div>
							<div class="col-sm-10 col-lg-3 offset-2 offset-lg-0">
								<div>{{transactionOne.trx_status_datetime | tanggal}}</div>
							</div>
							<div class="col-sm-10 col-lg-2 offset-2 offset-lg-0">
								<div>{{transactionOne.trx_status_datetime | jam}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-1 ml-2 ml-md-3 ml-lg-4">
						<div class="vertical-line background-gray ml-1"></div>
					</div>
				</div>
			</div>
			<div v-for="(value,index) in transactionOneLogReverse" :key="index">
				<div class="row">
					<div class="col-12 pt-3 pb-3 pt-lg-4 pb-lg-4 cus-box-shadow " :class="[value.trx_status_code == transactionOne.trx_status ? 'border-right-purple' : 'bg-green-light border-right-green']">
						<div class="row">
							<div class="col-sm-2 col-lg-1 text-md-center text-lg-center font-size-20 mt-2 mt-lg-n2 position-absolute" :class="[value.trx_status_code == transactionOne.trx_status ? 'text-purple' : 'text-green2']">
								<div><i class="far" :class="[value.trx_status_code == transactionOne.trx_status ? 'fa-compass' : 'fa-check-circle']"></i></div>
							</div>
							<div class="col-sm-10 col-lg-6 offset-2 offset-lg-1" v-if="value.trx_status_code == 5">
								<div>Dibatalkan oleh Mobile Counter</div>
							</div>
							<div class="col-sm-10 col-lg-6 offset-2 offset-lg-1" v-else>
								<div>{{value.trx_status_code | toStatus}}</div>
							</div>
							<div class="col-sm-10 col-lg-3 offset-2 offset-lg-0">
								<div>{{value.trx_status_datetime | tanggal}}</div>
							</div>
							<div class="col-sm-10 col-lg-2 offset-2 offset-lg-0">
								<div>{{value.trx_status_datetime | jam}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-if="index!==transactionOneLogReverse.length-1">
					<div class="col-1 ml-2 ml-md-3 ml-lg-4">
						<div class="vertical-line background-gray ml-1"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	computed: {
		...mapState('transactionList', ['transactionOne']),
		transactionOneLogReverse(){
			if(this.transactionOne.trx_status==9) {
				let arr = Object.assign([],this.transactionOne.trx_status_log)
				arr.reverse()
				arr.shift()
				return arr
			} else {
				let arr = Object.assign([],this.transactionOne.trx_status_log)
				return arr.reverse()
			}
		}
	},
}
</script>

<style>
.border-right-green {
	border-right: 5px solid #23ae9b;
}
.bg-green-light {
	background-color: #e9f8ea;
}
.border-right-purple {
	border-right: 5px solid #7C1CC6;
}
.text-green2 {
	color: #23ae9b;
}

</style>